<template>
  <i-form-item
    v-if="isFullWidth"
    :label="placeholder"
    prop="short_name"
  >
    <el-input
      v-model="innerQuery"
      class="tw-max-w-full"
      :class="[
        isFullWidth ? 'tw-w-full' : 'tw-w-80',
      ]"
      clearable
      @input="needToRunDebounceSearch = true"
      @keypress.enter.native="invokeSearch"
    />
  </i-form-item>
  <el-input
    v-else
    v-model="innerQuery"
    :placeholder="placeholder"
    class="tw-max-w-full"
    :class="[
      isFullWidth ? 'tw-w-full' : 'tw-w-80',
    ]"
    clearable
    @input="needToRunDebounceSearch = true"
    @keypress.enter.native="invokeSearch"
  >
    <template #prefix>
      <icon-search @click="invokeSearch" />
    </template>
  </el-input>
</template>

<script>
import { debounce } from 'lodash';

export default {
  props: {
    query: {
      type: String,
      default: '',
    },
    search: {
      type: Function,
      required: true,
    },
    placeholder: {
      type: String,
      required: true,
    },
    isFullWidth: {
      type: Boolean,
      default: false,
    },

  },
  data() {
    return {
      innerQuery: this.query,
      needToRunDebounceSearch: true,
    };
  },
  watch: {
    innerQuery(...args) {
      this.debouncedFetch(...args);
    },
    query(newVal) {
      this.innerQuery = newVal;
    },
  },
  created() {
    this.debouncedFetch = debounce(function() {
      if(this.innerQuery.length > 2 && this.needToRunDebounceSearch || this.innerQuery.length === 0) {
        this.search(this.innerQuery);
      }
    }, 300);
  },
  methods: {
    invokeSearch() {
      this.search(this.innerQuery);
    },
  },
};
</script>
